export default __webpack_public_path__ + "static/media/7.a0613a4c.jpg";